import { memo } from "react";

const Management = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_276_2913)">
      <path d="M20 0H0V20H20V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M16.25 2.5H3.75C3.05964 2.5 2.5 3.05964 2.5 3.75V16.25C2.5 16.9404 3.05964 17.5 3.75 17.5H16.25C16.9404 17.5 17.5 16.9404 17.5 16.25V3.75C17.5 3.05964 16.9404 2.5 16.25 2.5Z"
        stroke="currentColor"
        strokeWidth="1.53846"
        strokeLinejoin="round"
      />
      <path
        d="M10.8333 8.33331H5.83334"
        stroke="currentColor"
        strokeWidth="1.53846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1667 5.41669H5.83334"
        stroke="currentColor"
        strokeWidth="1.53846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_276_2913">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(Management);
